// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__YrI5c","items":"LoadingScreen_items__A+smA"};